import { BLUE_SCALE, GREEN_SCALE, RED_SCALE, YELLOW_SCALE } from '@/domain/reporting/reporting-shared.constants';
import { clamp } from '@/domain/reporting/reporting-shared.math';

export const getRatingBucketColor = (stars: number): string => {
    if (stars >= 4) {
        return '#34d399';
    }
    if (stars === 3) {
        return '#fbbf24';
    }
    return '#fb7185';
};

export const pickColorByRating = (rating: number | null): string => {
    if (typeof rating !== 'number') {
        return BLUE_SCALE[2];
    }

    if (rating >= 4) {
        const step = clamp(Math.round((rating - 4) * 4), 0, 4);
        return GREEN_SCALE[4 - step];
    }

    if (rating >= 3) {
        const step = clamp(Math.round((rating - 3) * 4), 0, 4);
        return YELLOW_SCALE[4 - step];
    }

    const step = clamp(Math.round((rating - 1) * 2), 0, 4);
    return RED_SCALE[4 - step];
};

export const getTextColorByBackground = (backgroundColor: string): string => {
    if (backgroundColor === GREEN_SCALE[0] || backgroundColor === RED_SCALE[0] || backgroundColor === BLUE_SCALE[0]) {
        return '#ffffff';
    }

    return '#0f172a';
};
